const backend = 'icsp-pybe.vercel.app';
export default backend;
